import { render } from "./IntegralAddress.vue?vue&type=template&id=6717092b&scoped=true&ts=true"
import script from "./IntegralAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntegralAddress.vue?vue&type=script&setup=true&lang=ts"

import "./IntegralAddress.vue?vue&type=style&index=0&id=6717092b&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6717092b"],['__file',"src/views/me/IntegralAddress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6717092b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6717092b', __exports__)) {
    console.log('reload')
    api.reload('6717092b', __exports__)
  }
  
  module.hot.accept("./IntegralAddress.vue?vue&type=template&id=6717092b&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6717092b', render)
  })

}


export default __exports__